import React from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";

const Dashboard = () => {
  document.title = "Dashboard | GraphicForce - Printesco";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Dashboard</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">Bienvenido a GraphicForce - Printesco</li>
                </ol>
              </Col>
            </Row>
          </div>
          <Row>
            <Col md={4}>
              <Card>
                <CardBody>
                  <h5 className="card-title">Órdenes de Producción</h5>
                  <p className="text-muted">Gestiona las órdenes de producción activas y finalizadas.</p>
                  <Link to="/produccion/orden-produccion" className="btn btn-primary btn-sm">
                    Ver Órdenes
                  </Link>
                </CardBody>
              </Card>
            </Col>
            <Col md={4}>
              <Card>
                <CardBody>
                  <h5 className="card-title">Planificador de Tareas</h5>
                  <p className="text-muted">Organiza y planifica las tareas de producción.</p>
                  <Link to="/produccion/planificador-tareas" className="btn btn-primary btn-sm">
                    Ver Planificador
                  </Link>
                </CardBody>
              </Card>
            </Col>
            <Col md={4}>
              <Card>
                <CardBody>
                  <h5 className="card-title">Inventarios</h5>
                  <p className="text-muted">Controla las entradas, salidas y solicitudes de inventario.</p>
                  <Link to="/inventarios/materiales" className="btn btn-primary btn-sm">
                    Ver Inventarios
                  </Link>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
